import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommArrowUpIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.24112 9.30181C5.94823 9.00892 5.94823 8.53405 6.24112 8.24115L10.534 3.94826C10.5421 3.94018 10.5502 3.93206 10.5584 3.9239C10.7033 3.7788 10.8601 3.62191 11.0103 3.50733C11.1862 3.37309 11.438 3.22859 11.7715 3.22859C12.1049 3.22859 12.3567 3.37309 12.5326 3.50733C12.6828 3.62191 12.8396 3.7788 12.9845 3.9239C12.9927 3.93206 13.0008 3.94018 13.0089 3.94826L17.3018 8.24115C17.5947 8.53405 17.5947 9.00892 17.3018 9.30181C17.0089 9.59471 16.534 9.59471 16.2411 9.30181L11.9482 5.00892C11.8782 4.93886 11.8214 4.8821 11.7715 4.83378C11.7215 4.8821 11.6647 4.93886 11.5947 5.00892L7.30178 9.30181C7.00889 9.59471 6.53402 9.59471 6.24112 9.30181Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M11.7715 3.77148C12.1857 3.77148 12.5215 4.10727 12.5215 4.52148L12.5215 20.0215C12.5215 20.4357 12.1857 20.7715 11.7715 20.7715C11.3572 20.7715 11.0215 20.4357 11.0215 20.0215L11.0215 4.52148C11.0215 4.10727 11.3572 3.77148 11.7715 3.77148Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
